import {DragContext, Draggables} from '../../business/drag_context';
import {Presenter} from '../support/with_presenter';
import {EstimatesRepository} from '../../persistence/estimates_repository';
import {Estimate} from '../../models/estimate';
import {SprintCreater} from '../../business/sprint_creater';

export class SprintAddButtonPresenter implements Presenter {
    public saving: boolean = false;
    public hours: number = 30;
    public isExtra: boolean = false;
    public modalVisible = false;
    public estimateId: number;

    public get estimates(): Estimate[] {
        return this.estimatesRepository.all();
    }

    constructor(
        private employeeId: number,
        private date: Date,
        private dragContext: DragContext,
        private estimatesRepository: EstimatesRepository,
        private sprintCreater: SprintCreater,
    ) {
        this.estimateId = this.estimatesRepository.all()[0].id;
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public onAddClick() {
        this.modalVisible = true;
    }

    public handleDragStart() {
        this.dragContext.register({
            type: Draggables.CreateSprintButton,
            employeeId: this.employeeId,
            from: this.date,
            till: null,
        });
    }

    public handleDragEnd() {
        this.dragContext.clear();
    }

    public onRequestModalClose() {
        this.modalVisible = false;
    }

    public onHoursChange(hours: number) {
        this.hours = hours;
    }

    public onIsExtraChange(isExtra: boolean) {
        this.isExtra = isExtra;
    }

    public onEstimateIdChange(estimateId: number) {
        this.estimateId = estimateId;
    }

    public async onSaveClick() {
        try {
            this.saving = true;
            await this.sprintCreater.create(
                this.employeeId,
                this.estimateId,
                this.hours,
                this.isExtra,
                this.date,
                this.date,
            );
        } finally {
            this.saving = false;
        }
        this.modalVisible = false;
    }

    public onSubmit() {
        this.onSaveClick();
    }
}
